import styles from './App.module.scss'
import { Routes, Route } from 'react-router-dom'
import routes from './routes/routes'

function App() {
  return (
    <div className={styles.container}>
      <main className={styles.contentWrapper}>
        <Routes>
          <Route path={routes.LoginPage.path} element={routes.LoginPage.page} />
          <Route
            path={routes.ContactList.path}
            element={routes.ContactList.page}
          />
          <Route
            path={routes.DialerPage.path}
            element={routes.DialerPage.page}
          />
          <Route
            path={routes.DialerOnCallPage.path}
            element={routes.DialerOnCallPage.page}
          />
          <Route
            path={routes.OutgoingCallPage.path}
            element={routes.OutgoingCallPage.page}
          />
          <Route
            path={routes.IncomingCallPage.path}
            element={routes.IncomingCallPage.page}
          />
          <Route
            path={routes.OngoingCallPage.path}
            element={routes.OngoingCallPage.page}
          />
          <Route
            path={routes.CallHistoryPage.path}
            element={routes.CallHistoryPage.page}
          />
        </Routes>
      </main>
    </div>
  )
}

export default App
